import { sql } from 'drizzle-orm';

export const SQL_NOW = sql`(unixepoch())`;

export const MAIL_SENDER = {
  email: 'hello@clew.app',
  name: 'Clew App',
};

// v1 — kept for migration reference
export const CONTEXT_RECORD_TYPES = {
  ATTACHMENT: 'ATTACHMENT',
  COMMENT: 'COMMENT',
  COMPLETE_TASK: 'COMPLETE_TASK',
  INCOMPLETE_TASK: 'INCOMPLETE_TASK',
} as const;

// v2
export const ITEM_TYPES = {
  COMMENT: 'COMMENT',
  FILE: 'FILE',
  TODO: 'TODO',
} as const;

export const ACTIVITY_TYPES = {
  ARCHIVED: 'ARCHIVED',
  COMMENT_ADDED: 'COMMENT_ADDED',
  COMMENT_EDITED: 'COMMENT_EDITED',
  FILE_ADDED: 'FILE_ADDED',
  MOVED: 'MOVED',
  PINNED: 'PINNED',
  PROCESS_CREATED: 'PROCESS_CREATED',
  SNOOZED: 'SNOOZED',
  TODO_ADDED: 'TODO_ADDED',
  TODO_COMPLETED: 'TODO_COMPLETED',
  TODO_UNCOMPLETED: 'TODO_UNCOMPLETED',
  UNARCHIVED: 'UNARCHIVED',
  UNPINNED: 'UNPINNED',
  UNSNOOZED: 'UNSNOOZED',
} as const;
